import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components';

const HeaderWrapper = styled.header`
  display: flex;
  padding: 4rem;
  justify-content: space-between;
  align-items: baseline;


  h1 {
  	margin: 0;
  	padding: 0;
  }

  @media(max-width: 500px) {
  	font-size: 1.5rem;
  	padding: 2rem;
  }
  a {
    text-decoration: none;
    color: black;
  }
`

const Header = () => (
  <HeaderWrapper>
   	<h1><Link to="/">Lachie's Music</Link></h1>
   	<span>© {new Date().getFullYear()}</span>
  </HeaderWrapper>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js